import { IconButton } from "@mui/material";
import { useEffect, useState } from "react"

import PopupFooter from "../../Popups/PopupFooter";
import PopupHeader from "../../Popups/PopupHeader";
import ModalBase from "../../Popups/ModalBase";

const roleColors: {
    [key: string]: {
        backgroundColor: string,
        color: string,
    }
} = {
    admin: {
        backgroundColor: '#DCE7B3',
        color: '#3C7828',
    },
    cpi_employee: {
        backgroundColor: '#D5E7E8',
        color: '#006D77',
    },
    prediction_analyst: {
        backgroundColor: '#F0C4E6',
        color: '#88156E',
    },
    model_trainer: {
        backgroundColor: '#BCBEF3',
        color: '#1E2298'
    },
    data_curator: {
        backgroundColor: '#F2D0B7',
        color: '#A45E2B',
    },
    org_admin: {
        backgroundColor: '#FDE68A',
        color: '#92400E',
    },
    service_account: {
        backgroundColor: '#E5E7EB',
        color: '#374151',
    },
}

const defaultRoleColor = {
    backgroundColor: '#E5E7EB',
    color: '#374151',
}

export default function RolesCell({
    value,
}: {
    value: string[],
}) {
    const [ shownRoles, setShownRoles ] = useState<string[]>([]);
    const [ open, setOpen ] = useState(false);
   
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        if (value.length > 2) {
            const roles = value.slice(0,2);
            setShownRoles(roles);
        } else {
            setShownRoles(value);
        }
    },[value]);

    return (
            <div className="flex justify-center items-center gap-2 py-4 px-6">
                {value[0] !== null && value.length > 0 ? (
                    <>
                    {shownRoles.map((role, i) => {
                        const { backgroundColor, color } = roleColors[role] || defaultRoleColor;
                        return (
                            <div style={{ backgroundColor, color }} key={i} className="py-1 px-3 rounded-lg font-semibold text-[12px] text-nowrap">{role}</div>
                        )
                    })}
                    {value.length > 2 && (
                        <div>
                            <IconButton size="small" onClick={handleOpen}>
                                <p className="text-[12px] font-semibold text-disable">+{value.length-2}</p>
                            </IconButton>

                            <ModalBase
                                open={open}
                                modalId="tags-modal"
                            >
                                <div className={`bg-white rounded-lg w-[400px] popup-max-height mx-auto`}>
                                    <div className='flex flex-col justify-center items-stretch popup-max-height'>
                                        <PopupHeader label="User Roles" closeFn={handleClose} hasOutline={false}/>

                                        <div className="w-full flex flex-col justify-start items-stretch gap-4 p-4">
                                            <div className="w-full border border-outline rounded-lg p-2">
                                                <div className="w-full flex justify-start items-start gap-2 flex-wrap max-h-[200px] overflow-y-auto">
                                                {value.map(role => {
                                                    const { backgroundColor, color } = roleColors[role] || defaultRoleColor;
                                                    return (
                                                        <div style={{ backgroundColor, color }} className="py-1 px-2 rounded-lg font-semibold text-[10px]">{role}</div>
                                                    )
}                                               )}
                                                </div>
                                            </div>
                                        </div>

                                        <PopupFooter 
                                            buttons={[{
                                                label: 'Close',
                                                type: 'primary',
                                                styling: 'solid',
                                                id: 'close-roles-btn',
                                                action: handleClose,
                                            }]}
                                            hasOutline={false}
                                        />
                                    </div>
                                </div>
                            </ModalBase>
                        </div>
                    )}
                    </>
                ) : (
                    <p className="text-[14px] text-nowrap font-medium text-default">None</p>
                )}
                
            </div>
    )
}